// src/hooks/hotelMealPlans/useGetHotelMealPlan.js
import { useQuery } from "@tanstack/react-query";
import { getHotelMealPlan } from "../../api/apiHotelMealPlans";

const QUERY_KEY = ["hotelMealPlan"];

const useGetHotelMealPlan = (id) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getHotelMealPlan(id),
    enabled: !!id,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelMealPlan: data?.data || null,
  };
};

export default useGetHotelMealPlan;
